<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

        <CardUpdatableHeader :row="row" :level="level">
          <template slot="title_create">
            <span class="headline">{{ $t('texts.cusser_create_title') }}</span>            
         </template>
          <template slot="title_update">
            <span class="headline">{{ $t('texts.cusser_update_title') }}</span>            
         </template>
          <template slot="title_delete">
            <span class="headline">{{ $t('texts.cusser_delete_title') }}</span>            
         </template>
          <template slot="subheader">
            <span>pour le client {{level.customer.cus_name}} ({{level.customer.cus_code}})</span>
         </template>
        </CardUpdatableHeader>

         <v-card-text>
            <v-container>
               <v-row>
                  <v-col cols="auto">
                     <p v-if="level.dialogValues.form_create">{{ $t('texts.ser_certificates_explanations_create') }}</p>
                     <p v-if="level.dialogValues.form_update">{{ $t('texts.ser_certificates_explanations_update') }}</p>
                     <p v-if="level.dialogValues.form_delete">{{ $t('texts.ser_certificates_explanations_delete') }}</p>
                  </v-col>
               </v-row>
            
               <h4>{{ $t('subtitles.inform_by_mail_of_certificates') }}</h4>
               <v-row no-gutters>
                  <v-col cols="12" sm="6">
                     <v-select
                        :items="items_warn_levels"
                        items-disabled="disabled"
                        type="number"
                        :value="row.xxx_inform_warn_level"
                        :disabled="level.dialogValues.form_delete"
                        :label="$t('texts.xxx_inform_warn_level')"
                        v-on:change="change_warnlevel"
                     >
                     </v-select>
                  </v-col>
               </v-row>

               <h5>{{ $t('subtitles.inform_to_customer') }} :</h5>
               <v-row no-gutters>
                  <v-col cols="12" sm="6">
                     <v-text-field dense v-model="row.xxx_inform_to_emails" maxlength="400" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_inform_to_emails')" :hint="$t('hints.xxx_inform_to_emails')"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                  <ddoSelectMailprofile :callbacks="MPRTOcallbacks" ref="mySelectMPRTO" :disabled="row.xxx_inform_to_emails==null" :options="MPRTOoptions"/>
                  </v-col>
               </v-row>
               <h5>{{ $t('subtitles.inform_to_manager') }} :</h5>
               <v-row>
                  <v-col cols="12" sm="6">
                     <v-text-field dense v-model="row.xxx_inform_cc_emails" maxlength="400" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_inform_cc_emails')" :hint="$t('hints.xxx_inform_cc_emails')"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                  <ddoSelectMailprofile :callbacks="MPRCCcallbacks" ref="mySelectMPRCC" :options="MPRCCoptions"/>
                  </v-col>
               </v-row>

               <v-row>
                  <v-col v-if="!level.dialogValues.form_create" cols="auto">
                     <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}<br/>
                     <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}
                  </v-col>
               </v-row>

            </v-container>

         </v-card-text>

        <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
    </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelectMailprofile from '@/components/ddoSelectMailprofile.vue';

export default {
   name: 'CardUpdatableCUSPLFCERTIFICATES',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelectMailprofile
   },
   data: function () {
      return {
         MPRTOcallbacks: {},
         MPRTOoptions: {
            initial: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "mpr_name",
            item_value: "mpr_pk",
            item_disabled: "",
            hide_selected: true,
            filter_by_platform: { plf_pk: null, exclusive: true },
            label: i18n.t('texts.xxx_mailprofile_to'),
         },

         MPRCCcallbacks: {},
         MPRCCoptions: {
            initial: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "mpr_name",
            item_value: "mpr_pk",
            item_disabled: "",
            hide_selected: true,
            filter_by_platform: { plf_pk: null, exclusive: true },
            label: i18n.t('texts.xxx_mailprofile_cc'),
         },

         callbacks: {
         },

         items_warn_levels: [ { value: 0, text: i18n.t('texts.level_ok') }, { value: 1, text: i18n.t('texts.level_warning') }, { value: 2, text: i18n.t('texts.level_error') }  ],
      }
   },

   created() {
      this.MPRTOcallbacks.refresh_rows = this.build_select_mpr;
      this.MPRTOcallbacks.change = this.change_mpr_to;
      this.MPRCCcallbacks.refresh_rows = this.build_select_mpr;
      this.MPRCCcallbacks.change = this.change_mpr_cc;
   },

   mounted() {
      if ( this.level.row.plf_pk!=null ) {
         this.MPRTOoptions.filter_by_platform.plf_pk = this.level.row.plf_pk;
         this.MPRCCoptions.filter_by_platform.plf_pk = this.level.row.plf_pk;
      } else {
         this.MPRTOoptions.filter_by_platform.plf_pk = null;
         this.MPRCCoptions.filter_by_platform.plf_pk = null;
      }
   },

   /*
    * This is the best way to watch an Object :
    * - set a hanlder on it,
    * - and, most important : deep=true to watch over properties
    */ 
   watch: {
      row: {
         handler: function (val,oldVal) {
            this.loadOtherInformations(val,oldVal)
         },
         deep: true
      }
   },

   methods: {

      loadOtherInformations(row,oldRow) {
         console.log('loadOtherInformations, row='+JSON.stringify(row))
         this.MPRTOoptions.filter_by_platform.plf_pk = row.plf_pk;
         this.MPRCCoptions.filter_by_platform.plf_pk = row.plf_pk;
         this.$refs.mySelectMPRTO.refresh_rows();
         this.$refs.mySelectMPRCC.refresh_rows();
      },

      async build_select_mpr(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'mailprofile');
         this.loading = false;
         return { errorinfos, api_response }
      },
      async change_mpr_to(value,item=null) {
         if ( item!=null) {
            this.level.row.mpr_pk = item.mpr_pk;
         } else {
           this.level.row.mpr_pk = null;
         }
      },
      async change_mpr_cc(value,item=null) {
         if ( item!=null) {
            this.level.row.mpr_pk_cc = item.mpr_pk;
         } else {
           this.level.row.mpr_pk_cc = null;
         }
      },
      async change_active(value) {
         if ( value ) { this.level.row.xxx_active=1; } else { this.level.row.xxx_active=0; }
      },

      change_warnlevel(value) {
         this.row.xxx_inform_warn_level = value;
      },

   }
}
</script>